module.exports = {"available":"Ledigt","booked":"Bokad","occupied":"Belagd","booked-occupied":"Bokad / Belagd","used":"begagnad","until":"till","all-day":"hela dagen","page_over_total":"Sidan {page} av {total}","room-name":"RUMS NAMN","current-booking":"PÅGÅENDE","next-booking":"NÄSTA","unknown":"Okänd","floors":"Våning","today":"idag","no_bookings":"Inga möten är bokade idag","no_information":"Ingen information tillgänglig","description":"Beskrivning","capacity":"Kapacitet","allocated":"Tilldelad","booked-occupied-allocated":"Bokad / Belagd / Tilldelad"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/sv.json
// module id = 35gq
// module chunks = 2